import './App.css';
import {BrowserRouter as Router, useRoutes} from 'react-router-dom';
import {ConfigProvider, Spin} from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import Routes from './router/index';
import React, {useEffect, useState} from "react";
import mainConfig from "./config";
import SvgIcon from "./components/svgIcon";
import {connect} from "react-redux";

const RouterElement = () => {
    let RoutesEs = useRoutes(Routes);
    return RoutesEs;
};

function App(props) {
    let [loading, setLoading] = useState(true);
    useEffect(async () => {
        let data = window.localStorage.getItem('commercialUserData');
        console.log(data);
        setTimeout(() => {
            if(data) {
                props.saveUserInfo(JSON.parse(data));
                setLoading(false);
            } else {
                setLoading(false);
            }
        }, 500)

    }, []);
    return loading ? (<div className="appLoading">
            <Spin tip="加载中..." spinning={loading} size={"large"} style={{fontSize: '45px'}}
                  indicator={<SvgIcon iconClass="loading"/>}/>
        </div>) :
        (
                <Router>
                    <RouterElement/>
                </Router>
        )
}

const stateToProps = (state) =>{
    return{
        login: state.login
    }
}

const dispathToProps = (dispatch) =>{
    return{
        saveUserInfo(data){
            const action ={
                type:'saveUserInfo',
                data
            }
            dispatch(action)
        },
        clearUserInfo(){
            const action ={
                type:'clearUserInfo'
            }
            dispatch(action)
        },
    }
}

export default connect(stateToProps, dispathToProps)(App);
